import { render, staticRenderFns } from "./InstituteChainCreate.vue?vue&type=template&id=0774b9b4"
import script from "./InstituteChainCreate.vue?vue&type=script&lang=js"
export * from "./InstituteChainCreate.vue?vue&type=script&lang=js"
import style0 from "./InstituteChainCreate.vue?vue&type=style&index=0&id=0774b9b4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports